// Copyright 2026. WebPros International GmbH. All rights reserved.
import * as React from 'react';

import {
    Icon as UIIcon,
    IconName,
} from '@plesk/ui-library';

import { ReactComponent as DisasterRecoveryIcon } from 'common/icons/disaster-recovery.svg';
import { ReactComponent as ShieldFilledIcon } from 'common/icons/shield-filled.svg';
import { ReactComponent as ShieldIcon } from 'common/icons/shield.svg';
import { ReactComponent as ShieldAttentionFilledIcon } from 'common/icons/shield-attention-filled.svg';
import { ReactComponent as ShieldUnavailableFilledIcon } from 'common/icons/shield-unavailable-filled.svg';
import { ReactComponent as ShieldPausedIcon } from 'common/icons/shield-paused.svg';
import { ReactComponent as ShieldErrorIcon } from 'common/icons/shield-error.svg';
import { ReactComponent as HighAvailabilityIcon } from 'common/icons/high-availability.svg';
import { ReactComponent as ShieldNotEligibleIcon } from 'common/icons/shield-not-eligible.svg';
import { ReactComponent as StoragesIcon } from 'common/icons/storages.svg';
import { ICONS as UI_ICONS } from 'common/constants';

export enum Icons {
    DISASTER_RECOVERY = 'disaster-recovery',
    HIGH_AVAILABILITY = 'high-availability',
    STORAGES = 'storages',
    SHIELD_FILLED = 'shield-filled',
    SHIELD = 'shield',
    SHIELD_ATTENTION_FILLED = 'shield-attention-filled',
    SHIELD_UNAVAILABLE_FILLED = 'shield-unavailable-filled',
    SHIELD_PAUSED = 'shield-paused',
    SHIELD_ERROR = 'shield-error',
    SHIELD_NOT_ELIGIBLE = 'shield-not-eligible',
}

export const ICONS = {
    [Icons.DISASTER_RECOVERY]: DisasterRecoveryIcon,
    [Icons.HIGH_AVAILABILITY]: HighAvailabilityIcon,
    [Icons.STORAGES]: StoragesIcon,
    [Icons.SHIELD_FILLED]: ShieldFilledIcon,
    [Icons.SHIELD]: ShieldIcon,
    [Icons.SHIELD_ATTENTION_FILLED]: ShieldAttentionFilledIcon,
    [Icons.SHIELD_UNAVAILABLE_FILLED]: ShieldUnavailableFilledIcon,
    [Icons.SHIELD_PAUSED]: ShieldPausedIcon,
    [Icons.SHIELD_ERROR]: ShieldErrorIcon,
    [Icons.SHIELD_NOT_ELIGIBLE]: ShieldNotEligibleIcon,
};

export interface IIconProps extends React.ComponentProps<typeof UIIcon> {
    name?: UI_ICONS | IconName | Icons | string;
}

export function Icon({ name, ...props }: IIconProps) {
    if (typeof name === 'string' && ICONS[name]) {
        const IconComponent = ICONS[name];
        return (
            <UIIcon
                {...props}
            >
                <IconComponent/>
            </UIIcon>
        );
    }

    return (
        <UIIcon
            name={name}
            {...props}
        />
    );
}
